<script setup>
import { useRoute } from 'vue-router'
import BottomNavButton from '../BottomNavButton.vue';
import houseIcon from '~/assets/icon_logo_house.svg'
import iconChildren from '~/assets/icon_children.svg'
import iconResources from '~/assets/icon_puzzle.svg'
import iconCalendar from '~/assets/icon_calendar.svg'
import { useAppStore } from '../../stores'

const route = useRoute()

const isCurrent = (routeName) => {
  if (routeName === '/') {
    return route.path === routeName
  }
  return route.path.includes(routeName)
}
</script>
<template>
    <div class="z-50 w-full h-20 bg-white border-t border-gray-200">
      <div class="grid h-full max-w-full md:mx-w-lg grid-cols-3 mx-auto font-medium">
        <BottomNavButton :is-current="isCurrent('/')" button-text="Dashboard" path="/">
          <img class="w-10 h-10 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 20 20" :src="houseIcon" />
        </BottomNavButton>
        <BottomNavButton :is-current="isCurrent('children') || isCurrent('readiness') || isCurrent('family')" button-text="My Children" path="/children">
          <img class="w-10 h-10 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 20 20" :src="iconChildren" />
        </BottomNavButton>
        <BottomNavButton :is-current="isCurrent('resources')" button-text="Resources" path="/resources">
          <img class="w-10 h-10" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 20 20" :src="iconResources" />
        </BottomNavButton>
        <BottomNavButton :is-current="isCurrent('calendar')" button-text="Calendar" path="/calendar"  v-if="useAppStore.showContracts" >
          <img class="w-10 h-10" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 20 20" :src="iconCalendar"/>
        </BottomNavButton>
      </div>
  </div>
</template>